import React, { useEffect, useState } from 'react'
import { Col, Form, FormInstance, Input, Row } from 'antd'
import { EmailTemplate, EmailTemplateResp } from 'types/globalTypes'
import moment from 'moment'
import ConditionsToSend from './ConditionToSend'
import CustomTime from './CustomTime'
import Recepient from './Recepients/Recepient'
import { formValidated } from 'helper/utility'
import {
  EventEmailTemplatePayload,
  EventEmailTemplateResp,
  RecepientToSend,
} from 'types/event/eventStep5'

interface TemplateDetailsProps {
  form: FormInstance
  payload: EventEmailTemplatePayload
  setPayload: React.Dispatch<React.SetStateAction<EventEmailTemplatePayload>>
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>
  data?: EventEmailTemplateResp | undefined
  reference?: 'event' | 'league' | 'organization' | 'class'
}

const TemplateDetails: React.FC<TemplateDetailsProps> = ({
  form,
  payload,
  setPayload,
  setCurrentStep,
  data,
  reference,
}) => {
  const [isCustomTime, setIsCustomTime] = useState<boolean>(false)
  const [recepientPayload, setRecepientPayload] = useState<RecepientToSend>(
    data
      ? {
          ...data.recipientsToSend,
          eventDates: data.recipientsToSend?.eventDates
            ? data.recipientsToSend.eventDates.map(date =>
                moment(date).format('YYYY-MM-DD'),
              )
            : undefined,
        }
      : undefined,
  )

  const formSchema = {
    templateName: data ? data.templateName : undefined,
    subject: data ? data.subject : undefined,
    timeQuantity: data ? data.conditionsToSend?.timeQuantity : undefined,
    timePeriod: data ? data.conditionsToSend?.timePeriod : undefined,
    timeFrame: data ? data.conditionsToSend?.timeFrame : undefined,
    conditionType: data
      ? data.customTimeToSend
        ? 'customTimeToSend'
        : data.conditionsToSend?.conditionType
      : undefined,
    date: data ? moment(data.customTimeToSend) : undefined,
    time: data ? moment(data.customTimeToSend) : undefined,
  }

  const onFinish = values => {
    if (!formValidated(values)) return
    const finalPayload: EmailTemplate = {
      ...values,
      recipientsToSend: {
        admissionTicketIds: recepientPayload
          ? recepientPayload.admissionTicketIds
          : undefined,
        additionalOptionIds: recepientPayload
          ? recepientPayload.additionalOptionIds
          : undefined,
        dropInTicketIds: recepientPayload
          ? recepientPayload.dropInTicketIds
          : undefined,
        gender: recepientPayload ? recepientPayload.gender : undefined,
        minAge: recepientPayload ? recepientPayload.minAge : undefined,
        maxAge: recepientPayload ? recepientPayload.maxAge : undefined,
        eventDates: recepientPayload ? recepientPayload.eventDates : undefined,
      },
    }
    if (isCustomTime) {
      finalPayload.customTimeToSend = moment
        .utc(
          `${moment(values.date).format('YYYY-MM-DD')} ${moment
            .utc(values.time)
            .format('HH:mm')}`,
        )
        .format()
    } else {
      finalPayload.conditionsToSend = {
        timeQuantity: values.timeQuantity,
        timePeriod: values.timePeriod,
        timeFrame: values.timeFrame,
        conditionType: values.conditionType,
      }
    }

    setPayload(finalPayload)
    setCurrentStep(1)
  }

  useEffect(() => {
    if (data && data.customTimeToSend) {
      setIsCustomTime(true)
    }
  }, [data])

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        initialValues={formSchema}
        onFinish={onFinish}
      >
        <Row gutter={10}>
          <Col>
            <label className="input-label required-input">Template name</label>
            <Form.Item className="form-control" name="templateName">
              <Input
                className="custom-input-field"
                placeholder="Template name"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={10}>
          <Col>
            <label className="input-label required-input">Email subject</label>
            <Form.Item className="form-control" name="subject">
              <Input
                className="custom-input-field"
                placeholder="Enter subject"
              />
            </Form.Item>
          </Col>
        </Row>

        <Recepient
          recepientPayload={recepientPayload}
          setRecepientPayload={setRecepientPayload}
          reference={reference}
        />

        <div className="mt-15px">
          <label className="input-label">Condition to send</label>
          {!isCustomTime ? (
            <ConditionsToSend
              setIsCustomTime={setIsCustomTime}
              reference={reference}
            />
          ) : (
            <CustomTime setIsCustomTime={setIsCustomTime} />
          )}
        </div>

        <div
          className="px-20px py-15px radius-12 mt-20px"
          style={{ background: '#FFF9E1' }}
        >
          <p className="text-14 w-400">
            Want to trigger an action immediately after something else occurs?
            Set its timing to 0 minutes, days, etc.{' '}
          </p>
        </div>
      </Form>
    </>
  )
}

export default TemplateDetails
